import React from "react";
import PropTypes from "prop-types";

import OFormPasswordValidator from "./OFormPasswordValidator";

function PasswordValidator({ password, rules, className }) {
  return rules.map((rule) => (
    <div key={rule} className={className}>
      <OFormPasswordValidator password={password} rule={rule} />
    </div>
  ));
}

PasswordValidator.defaultProps = {
  className: "",
  rules: [],
};

PasswordValidator.propTypes = {
  password: PropTypes.string.isRequired, // The password to validate
  rules: PropTypes.arrayOf(PropTypes.string), // The rules to validate
  className: PropTypes.string, // The class name to apply to the validator
};

export default PasswordValidator;
